const TextElementModel = {
  content: { pl: '' },
};

export default TextElementModel;
